import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { Form } from 'components';
import SelectedItems from 'pages/ModulePage/components/SelectedItems/SelectedItems';
import SelectItemsModal from 'pages/ModulePage/components/SelectItemsModal/SelectItemsModal';
import capitalize from 'utils/capitalize';
import { useFormikContext } from 'formik';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const getLookImage = (look) => look?.media_thumbnails?.[0] || placeholderImage;

const getLookKey = (look) => look.uid;

const filterLookByName = (item, query) =>
  (item.name || '').toLowerCase().includes(query.toLowerCase());

const getLookItemCardProps = (look, { t }) => ({
  imageSrc: getLookImage(look),
  imageAlt: look.name || 'Look',
  badge: look.look_type
    ? look.look_type === 'template'
      ? t('templateLook')
      : capitalize(look.look_type)
    : null,
  title: look.name || null,
  meta: [{ label: t('retailerName'), value: look.retailer_name || t('notSpecified') }],
});

export const createLooksConfig = (useAvailableItems) => {
  const LooksConfig = () => {
    const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });
    const { values, setFieldValue } = useFormikContext();
    const { items, isLoading } = useAvailableItems();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [search, setSearch] = useState('');

    const selectedItems = useMemo(() => values.selectedItems || [], [values.selectedItems]);

    const filteredItems = useMemo(() => {
      if (!search.trim()) return items;
      return items.filter((item) => filterLookByName(item, search.trim()));
    }, [items, search]);

    return (
      <>
        <Form.GroupHorizontal label={t('selectedItems')}>
          <SelectedItems
            isLoading={isLoading}
            items={selectedItems}
            setItems={(next) => setFieldValue('selectedItems', next)}
            getItemKey={getLookKey}
            getItemCardProps={getLookItemCardProps}
            onOpenModal={() => setIsModalOpen(true)}
          />
        </Form.GroupHorizontal>
        <SelectItemsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={(next) => setFieldValue('selectedItems', next)}
          initialSelected={selectedItems}
          items={filteredItems}
          isLoading={isLoading}
          getItemKey={getLookKey}
          getItemCardProps={getLookItemCardProps}
          onSearch={setSearch}
          selectedFirst
        />
      </>
    );
  };

  return LooksConfig;
};
